export enum Role {
  BORROWER = 'BORROWER',
  LENDER = 'LENDER',
}
